import styled from 'styled-components'
import {
  flexDirection,
  FlexDirectionProps,
  height,
  HeightProps,
  width,
  WidthProps,
} from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: ${themeGet('gradients.publicBackground')};
`

export const Content = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps & HeightProps & WidthProps>`
  display: flex;
  width: 100%;
  border-radius: 16px;
  overflow: auto;
  box-shadow: ${themeGet('shadows.block')};

  ${width}
  ${flexDirection}
  ${height}
`

export const EventHolder = styled.div`
  display: flex;
  padding: ${themeGet('space.9')}px;
  width: 100%;
  background-color: ${themeGet('colors.background.panel')};
`

export const FormHolder = styled.div<WidthProps & HeightProps>`
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  padding: ${themeGet('space.9')}px;
  background-color: ${themeGet('colors.background.paperElevation24')};
  align-items: center;

  ${width}
  ${height}
`
